module.exports = __webpack_public_path__ + "static/media/image77.929f471c.png";